"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _mobxReact = require("mobx-react");

var _StaggeredScaleIn = _interopRequireDefault(require("./effect/animation/StaggeredScaleIn"));

var _styling = require("../toolkit/styling");

var illustrations = _interopRequireWildcard(require("../toolkit/illustrations"));

//
//  src/Illustration.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 6/1/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* Lego Components */

/* Lego Toolkit */
var propDoc = {
  name: {
    required: true,
    type: "IllustrationName",
    description: "Name of the illustration to display. Illustrations should" + " be defined in the `lego/toolkit/illustrations.tsx` file"
  },
  alt: {
    required: true,
    type: "string",
    description: "Text alternative for the image, to support " + "accessibility and search engines"
  },
  animate: {
    required: false,
    type: "boolean",
    defaultValue: "false",
    description: "should the image animate into on load"
  }
};
var demoProps = {
  name: "gmv",
  alt: "illustration of GMV"
};
var Illustration = (0, _mobxReact.observer)(function (props) {
  var alt = props.alt,
      name = props.name,
      _props$animate = props.animate,
      animate = _props$animate === void 0 ? false : _props$animate,
      className = props.className,
      style = props.style,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["alt", "name", "animate", "className", "style"]);
  var illustrationSrc = illustrations[name];

  if (illustrationSrc == null) {
    return null;
  }

  var Content = function Content() {
    return /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({
      src: illustrationSrc,
      alt: alt,
      draggable: false,
      style: {
        width: "100%",
        height: "100%"
      }
    }, otherProps));
  };

  if (!animate) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _styling.css)(className, style)
    }, /*#__PURE__*/_react["default"].createElement(Content, null));
  }

  return /*#__PURE__*/_react["default"].createElement(_StaggeredScaleIn["default"], {
    className: (0, _styling.css)(className, style),
    startScale: 0.8,
    animationDurationMs: 200
  }, /*#__PURE__*/_react["default"].createElement(Content, null));
});
Illustration.propDoc = propDoc;
Illustration.demoProps = demoProps;
var _default = Illustration;
exports["default"] = _default;